import React from "react";
import ReactDOM from "react-dom";
import Nav from "../components/Nav";
import { Navigate } from "react-router-dom";
import sanityClient from "../client";

import Upload from "../components/upload/Upload";

class MedicalRecordsUpload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      uploadedFileName: "",
      file: "",
      fileUrl: "",
      loading: false,
      shouldRedirect: false,
    };

    this.reader = new FileReader();
    // this.reader.addEventListener(
    //   "load",
    //   function () {
    //     this.fileData = this.reader.result;
    //     console.log("Set fileData to");
    //     console.log(this.fileData);
    //   },
    //   false
    // );
    // this.file = null;
    // this.fileData = null;
  }

  componentDidMount() {
    const query = `*[_type == "intakeFormSettings"]`;
    const params = {};

    sanityClient.fetch(query, params).then((intakeFormSettings) => {
      console.log("intakeFormSettings:");
      intakeFormSettings.forEach((settings) => {
        console.log(`${settings._id} (${settings.originalStatement})`);
        this.setState({ originalStatement: settings.originalStatement });
        this.setState({ formTitle: settings.title });
      });
    });
  }

  handleFileChange = (e) => {
    console.log("handleFileChange");
    const fileData = {
      fileObj: null,
      fileUrl: null,
    };

    fileData.fileObj = e.target.files[0];
    fileData.fileUrl = URL.createObjectURL(e.target.files[0]);

    let uploadName = `${fileData.fileObj.name}-${Date.now()}`.replace(
      /\s/g,
      ""
    );

    this.setState({
      file: new File([fileData.fileObj], uploadName, {
        type: "application/pdf",
      }),
      fileUrl: fileData.fileUrl,
      uploadedFileName: uploadName,
    });
  };

  onSubmit = (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    console.log("this.state.file");
    console.log(this.state.file);
    if (this.state.file) {
      this.reader.readAsDataURL(this.state.file);
    }
    let uploadName = this.state.uploadedFileName;
  };

  onSkip = (event) => {
    event.preventDefault();
    this.setState({ loading: false, shouldRedirect: true });
  };

  render() {
    return (
      <form className="mt-4">
        <div className="field container m-5">
          <p className="title is-4">{this.state.formTitle}</p>
          <p className="subtitle is-4">Medical Records Upload</p>
          <label className="label" htmlFor="medicalRecordsAvailableForReview">
            Please upload any medical records that you have available for this
            review. We accept pdf, png, and/or jpeg files.
          </label>
          <label>Note: Medical record upload is optional.</label>
          <div className="control mb-3">
            <Upload />
            {this.state.shouldRedirect && (
              <Navigate replace to="/terms-and-conditions" />
            )}
          </div>

          <Nav isMedicalRecordsUpload="is-underlined has-text-weight-bold"></Nav>
        </div>
      </form>
    );
  }
}

export default MedicalRecordsUpload;
